<template>
  <div class="grid gap-4 grid-cols-1 md:grid-cols-6 sm:gap-6 lg:gap-8">
    <slot />
  </div>
</template>
